import React from 'react';
const Aspnethosting = () => {
  return(
<>
    <div className="bg">
        <div className="container">
            <h1 className="fs-1 text-center pt-5">Windows ASP.NET Web Hosting</h1>
            <p className="text-center">Supercharge your website's security while boosting your search engine rankings with a complimentary Let's Encrypt SSL certificate, effortlessly installed via our convenient one-click installer within the user-friendly Plesk panel. Explore the limitless possibilities of creating stunning websites and powerful applications with our ASP.NET and MSSQL support. Your digital journey begins here.</p>
            <div className="row mt-5">
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited Storage</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited Transfer</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Free Website Migration</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 25 Websites</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited Email</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Global Content Caching</li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <ul>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; FREE SSL Certificates</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Intershield Protection</li>
                        <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 30 Days Money Back Guarantee</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-4 mt-5">
                    <img src="https://www.interserver.net/webhosting/assets/images/about-windows.jpg" className="w-100"/>
                </div>
                <div className="col-md-8">
                    <p className="fs-2">About Windows Web Hosting</p>
                    <p>There are multiple benefits of choosing Windows web hosting. First of all, when you want to develop a website using .net language, then Windows web hosting is naturally the first choice for you. Most of the people know how to operate Windows based system, and this is what makes it more appealing as anyone familiar with Windows operating system doesn't feel anything new especially when the user is creating and managing using the Windows hosting platform. Now coming to pricing then other web hostings are generally costly, but when it comes to Windows web hosting it is one the most efficient and pocket-friendly choice. Want more reasons? Keep scrolling and read endless benefits of Windows web hosting provided by us.</p>
                    <p>Our windows hosting packages offer the option to create as many email accounts as you want. We also secure and monitor our email services, preventing spam and keeping your accounts safe. Enhance your website security and boost Search Engine rankings with a free Let's Encrypt SSL certificate available in the one-click installer in your Plesk panel. Make amazing websites and applications with NODEJS (16), ASP.NET, MSSQL, five different versions of PHP, Perl and SSI. Simplify deployment process with Web Deploy and Plesk control panel. Apart from that know, Windows hosting gives you the freedom to work on Windows environment. Similarly, you can try out our Macintosh Web Hosting to get most from OS X and iOS platforms.</p>
                </div>
            </div>
            <div className="row mt-5">
                <h1 className="fs-1 text-center pt-5">Hosting Features</h1>
                <p className="text-center">Our unique solutions and expertise guarantee a superior experience!</p>
                <div className="row mt-5">
                    <div className="col-md-4">
                        <ul>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Weekly Backups</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Raid-10 Storage</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 10GB Cisco Network</li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <ul>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Unlimited FTP Accounts</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Speed Optimization</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Free CloudFlare CDN</li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <ul>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; SSD Caching Servers</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; Ultra Fast Web Server</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 30 Day Gurantee (?)</li>
                            <li><i class="bi bi-arrow-right"></i>&nbsp;&nbsp; 27/7 Support</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-4">
                    <img src="https://www.interserver.net/webhosting/assets/images/migration.svg" className="w-100"/>
                </div>
                <div className="col-md-8 mt-5">
                    <p className="fs-2">Free migration service </p>
                    <p>For a standard shared hosting migration please have a full cpanel backup ready for download. You do not need to upload it to your new interserver shared hosting account, however, doing so will save some time. The current interserver account should have no data in it, as the backup will overwrite any data</p>
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-8 mt-5">
                    <p className="fs-2">50% Server Capacity</p>
                    <p>Utilizing only 50% of available resources allows us to support the growth of our customer's websites without experiencing performance issues.</p>
                </div>
                <div className="col-md-4">
                    <img src="https://www.interserver.net/webhosting/assets/images/server-capa.png" className="w-100 p-5"/>
                </div>
            </div>
            <div className="row mt-5">
                <h1 className="fs-1 text-center pt-5">ASP.NET Web Hosting Features</h1>
            </div>
            <div className="row mt-5">
                <div className="col-md-4">
                    <div className="shadow pb-5 p-3 height_vh">
                        <table>
                            <tr>
                                <th><p className="fs-4 fw-bold text-center">Domain Names</p></th>
                                <th><p className="fs-4 fw-bold text-center">ASP.NET</p></th>
                            </tr>
                            <tr>
                                <td>Websites / Domains</td><td>25</td>
                            </tr>
                            <tr>
                                <td>Parked Domains</td><td>10</td>
                            </tr>
                            <tr>
                                <td>Unlimited Subdomains</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Discounted Domain Registration</td><td>$7.99/year</td>
                            </tr>
                            <tr>
                                <td>Free SSL Certificates</td>
                                <td><i class="bi bi-check"></i></td>
                            </tr>
                        </table>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5 w-100"><a href="Contactform" className='text-white p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="shadow pb-5 p-3 h-100">
                        <table>
                            <tr>
                                <th><p className="fs-4 fw-bold text-center">E-Mail Features</p></th>
                                <th><p className="fs-4 fw-bold text-center">ASP.NET</p></th>
                            </tr>
                            <tr>
                                <td>Unlimited E-Mail Accounts</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Guaranteed Mail Delivery (?)</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Unlimited Forwarders</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>WebMail Access</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>iPhone Supported</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>BlackBerry Supported</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Android Supported</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Windows Mobile Supported</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>MX Record Changes</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Spam Filtering</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>SSL Encryption</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Outgoing SMTP</td><td><i class="bi bi-check"></i></td>
                            </tr>
                        </table>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5 w-100"><a href="Contactform" className='text-white p-5'>Contact Us</a></button>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="shadow pb-5 p-3 h-100">
                        <table>
                            <tr>
                                <th><p className="fs-4 fw-bold text-center">Development</p></th>
                                <th><p className="fs-4 fw-bold text-center">Windows</p></th>
                            </tr>
                            <tr>
                                <td>25 MySQL DB</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>25 MariaDB 10</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>PHP up to 8.3</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Fast CGI</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Python is not supported - consider Linux standard hosting for python</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>25 Microsoft SQL 2019 Express DBs</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Web Deploy</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>URL Rewrite</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Mobile Websites Compatible</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Classic ASP</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>NodeJS</td><td><i class="bi bi-check"></i></td>
                            </tr>
                            <tr>
                                <td>Websockets</td><td><i class="bi bi-check"></i></td>
                            </tr>
                        </table>
                        <button type="submit" class="insuba-btn text-center p-2 fs-5 mt-5 w-100"><a href="Contactform" className='text-white p-5'>Contact Us</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
    );
};
 
export default Aspnethosting;